import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit, TemplateRef } from '@angular/core';

import { popoverAnimation } from '../../animations/popover.animation';
import { VexPopoverContent, VexPopoverRef } from './vex-popover-ref';

@Component({
  /*eslint-disable-next-line*/
  selector: 'vex-popover',
  templateUrl: './vex-popover.component.html',
  styleUrls: ['./vex-popover.component.scss'],
  animations: [popoverAnimation],
  imports: [NgTemplateOutlet, NgComponentOutlet],
})
export class VexPopoverComponent implements OnInit {
  private readonly popoverRef = inject(VexPopoverRef);

  renderMethod: 'template' | 'component' | 'text' = 'component';
  content: VexPopoverContent;
  context: any;

  ngOnInit() {
    this.content = this.popoverRef.content;

    if (typeof this.content === 'string') {
      this.renderMethod = 'text';
    }

    if (this.content instanceof TemplateRef) {
      this.renderMethod = 'template';
      this.context = {
        close: this.popoverRef.close.bind(this.popoverRef),
      };
    }
  }
}
